import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import Image from 'gatsby-plugin-sanity-image'
import PortableText from '../components/portable-text';
import {SlideDown} from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';

export default function CultureItem({culture, className, onMouseEnter, onMouseLeave}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={className}
      css={css`
        padding-top: 2rem;
        border-top: 1px solid var(--black);
        margin-bottom: 7rem;

        @media (max-width: 900px) {
          margin-bottom: 4rem;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          margin-bottom: 4rem;
          cursor: ${(culture._rawText?.length > 1) ? 'pointer' : 'default'};
        `}
        role="button"
        aria-expanded={(open) ? true : false}
        tabIndex="0"
        onClick={() => setOpen(!open)}
        onKeyPress={(e) => {
          e.persist();

          if (e.key === 'Enter') setOpen(!open);
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div
          className="type--medium"
          css={css`
            font-family: 'Maax Medium', sans-serif;
          `}
        >{culture.title}</div>
        {culture._rawText?.length > 1 && <div
          css={css`
            position: relative;
            top: -2px;
            line-height: 0;
            text-align: right;
            cursor: pointer;
            padding-right: 5px;
          `}
        >
          <span
            css={css`
              position: absolute;
              top: 9px;
              right: 5px;
              width: 11px;
              height: 1px;
              background-color: var(--black);
            `}
          ></span>
          <span
            css={css`
              position: absolute;
              top: 4px;
              right: 10px;
              width: 1px;
              height: 11px;
              background-color: var(--black);
              transform: rotate(${(!open) ? 0 : '90deg'});
              transition: transform 0.6s var(--curve);
            `}
          ></span>
        </div>}
      </div>
      <div
        css={css`
        `}
      >
        <PortableText
          css={css`
            > * {
              display: none;
            }

            > p:first-of-type {
              display: block;
            }
          `}
          blocks={culture._rawText}
        />
      </div>
      {culture._rawText?.length > 1 && <SlideDown
        css={css`
          transition: height 0.6s var(--curve);
        `}
      >
        {open ? 
          <div
            css={css`
              padding-bottom: 2rem;
            `}
          >
            <PortableText
              css={css`
                > p:first-of-type {
                  display: none;
                }
              `}
              blocks={culture._rawText}
            />
          </div> : null}
      </SlideDown>}
    </div>
  )
}
